export default __webpack_public_path__ + "static/media/slideshow_step3_fr.d059c4a5.png";